import { render, staticRenderFns } from "./ProductModalPrices.vue?vue&type=template&id=150d4df3&"
import script from "./ProductModalPrices.vue?vue&type=script&lang=js&"
export * from "./ProductModalPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports